// extracted by mini-css-extract-plugin
export default {"container":"WelcomeAdmin_container__sbicY","inputsContainer":"WelcomeAdmin_inputsContainer__4J2DR","content":"WelcomeAdmin_content__j5RSZ"};